import * as React from "react";

import ImageView, { SmartImageProps } from "../../../../components/SmartImage";
import DiscountInfoCard from "./DiscountInfoCard";
import { BottomViews } from "../BottomViews";
import { PriceViews } from "../PriceViews";
import { NameViews } from "../NameViews";
import { ActTagViewForPc } from "../ActTagViews";
import { ProductCardWrap, DescriptionWrap, ProductCardPoster } from "./styles";
import {
  LinkTargetType,
  ModuleLayoutStyle,
} from "../../../../services/playground";
import {
  TProductElement,
  PoolExtraInfo,
  ScoreOption,
} from "../../../../services/product";
import { transformAParam } from "utils/browser";
import { ShipTo24Hours as ShipTo24HoursBox } from "../ShipTo24Hours";

interface ProductElement extends TProductElement {
  priceCurrency?: string;
  originPriceCurrency?: string;
  priceSymbol?: string;
  originPriceSymbol?: string;
  originPriceBr?: boolean;
}

export interface ProductCardProps {
  product: ProductElement;
  width: string | number;
  posterRatio?: number;
  gridCol: number;
  layoutStyle: ModuleLayoutStyle;
  onClick?: (link?: string) => void;
  placeholderBg: string;
  collectOptions?: ScoreOption;
  smartImageProps?: Partial<SmartImageProps>;
  poolId?: string;
}

export class ProductCard extends React.PureComponent<ProductCardProps, {}> {
  constructor(props: ProductCardProps) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      product,
      gridCol,
      posterRatio = 1,
      layoutStyle,
      placeholderBg = "",
      collectOptions = {},
      smartImageProps = {},
      poolId,
    } = this.props;
    const {
      imgOnBottomLeft,
      imgOnTopLeft,
      imgOnTopRight,
      titleIcon,
      collect,
      actTags,
      shipIn24hours,
      flash,
    } = product.extra || ({} as PoolExtraInfo);
    const aProps = transformAParam({
      isInApp: false,
      link: product.url,
      aTarget: LinkTargetType.Blank,
      onClick: this.props.onClick,
    });
    const {
      price,
      priceCurrency,
      priceSymbol,
      originPrice,
      originPriceCurrency,
      originPriceSymbol,
      originPriceBr,
    } = product;
    return (
      <ProductCardWrap
        {...aProps}
        width={this.props.width}
        id={`${poolId}${product.gpid}`}
      >
        <ProductCardPoster
          posterRatio={posterRatio}
          layoutStyle={layoutStyle}
          style={{
            background: `url(${placeholderBg}) center`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            width: this.props.width,
          }}
        >
          <DiscountInfoCard
            imgOnTopRight={imgOnTopRight}
            imgOnTopLeft={imgOnTopLeft}
            imgOnBottomLeft={imgOnBottomLeft}
            flash={flash}
          />
          <ImageView
            src={product?.img}
            alt=""
            {...smartImageProps}
            online={true}
            placeholder={placeholderBg}
            fallbackSrc={placeholderBg}
            imgClass={"productImage"}
            fit={true}
          />
        </ProductCardPoster>

        <DescriptionWrap gridCol={gridCol}>
          <>
            <NameViews
              name={product.name}
              columnNum={actTags ? 1 : 2}
              titleTag={titleIcon?.img || ""}
            />
            {actTags && <ActTagViewForPc actTags={actTags} />}
            <PriceViews
              className={`priceView${ModuleLayoutStyle.Orange}`}
              price={price}
              originPrice={originPrice}
              priceCurrency={priceCurrency}
              originPriceCurrency={originPriceCurrency}
              priceSymbol={priceSymbol}
              originPriceSymbol={originPriceSymbol}
              originPriceBr={originPriceBr}
            />
            {collect && (
              <BottomViews
                columnNum={gridCol}
                collect={collect}
                collectOptions={collectOptions}
              />
            )}
            {shipIn24hours && <ShipTo24HoursBox text={shipIn24hours} />}
          </>
        </DescriptionWrap>
      </ProductCardWrap>
    );
  }
}
